import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=6fca1ed2&"
import script from "./breadcrumb.ts?vue&type=script&lang=js&"
export * from "./breadcrumb.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports